/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-props-no-spreading */
// importer la librairie de react
import React, { useEffect, useRef, useState } from "react"
import {
    Box,
    Stepper,
    Step,
    StepLabel,
    Typography,
    styled,
} from "@mui/material"
import DynamicParamsService from "../../../services/dynamicParams"
import DialogService from "../../../services/dialog"
import { DialogType } from "../../../models/dialog"
import StoreService from "../../../services/store"
import { PageConfig, CwComponentConfig } from "../../../models/pageConfig"
import StepperItem from "./stepperItem"

const CwStepper = (
    props: PageConfig<CwComponentConfig.Stepper> & {
        onChange?: (index: number, total: number) => void
    }
): React.JSX.Element => {
    const { config, name } = props
    // création de toute les variables à partir des config
    const { steps, useConfigListener, alternativeLabel } = config

    // crée la liste des composants présent dans la card et son setter

    const activeStepRef = useRef(0)
    const [activeStep, setActiveStep] = useState(activeStepRef.current)
    const [hasError, setHasError] = useState(false)
    const blockIfNotComplete = config.blockIfNotComplete || true
    const className = config.className || ""
    const classNameStepper = config.classNameStepper || ""
    const stepClassName = config.stepClassName || ""

    const init = () => {
        if (activeStep === steps.length)
            StoreService.getInstance().local.set(`${name}`, "completed")
        else if (activeStep < steps.length)
            StoreService.getInstance().local.set(
                `${name}`,
                steps[activeStep].name
            )
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeStep])
    useEffect(() => {
        let subId: string | null = null
        // abonnement aux changments de config
        if (useConfigListener)
            subId = DialogService.getInstance().subscribe(
                "all",
                DialogType.CONFIG,
                props.name,
                (param: any) => {
                    if (
                        param.action === "next" &&
                        activeStepRef.current < steps.length &&
                        !hasError
                    ) {
                        activeStepRef.current += 1
                        setActiveStep(activeStepRef.current)
                        if (props.onChange)
                            props.onChange(activeStepRef.current, steps.length)
                    }
                    if (param.action === "back" && activeStepRef.current > 0) {
                        activeStepRef.current -= 1
                        setActiveStep(activeStepRef.current)
                        if (props.onChange)
                            props.onChange(activeStepRef.current, steps.length)
                    }
                    init()
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isStepFailed = (step: number) => {
        // TODO vérification de chaque step
        setHasError(true)
    }
    const StyledStepper = styled(Stepper)(() => ({
        ".MuiStepLabel-labelContainer span": {
            fontSize: "20px",
        },
        ".MuiStepLabel-iconContainer": {
            fontSize: "30px",
        },
        ".MuiSvgIcon-root ": {
            fontSize: "inherit",
        },
        ".MuiStepIcon-text": {
            fill: "#fff",
        },
    }))
    return (
        <Box
            sx={{ width: "100%" }}
            className={`${className}`}
            display="flex"
            flexDirection={
                config.stepperOrientation &&
                config.stepperOrientation === "vertical"
                    ? "row"
                    : "column"
            }
        >
            <StyledStepper
                activeStep={activeStep}
                orientation={
                    config.stepperOrientation &&
                    config.stepperOrientation === "vertical"
                        ? "vertical"
                        : "horizontal"
                }
                className={`${classNameStepper} p-2 mb-2`}
                alternativeLabel={alternativeLabel || false}
            >
                {steps.map((step) => {
                    const stepProps: { completed?: boolean } = {}
                    const labelProps: {
                        optional?: React.ReactNode
                        error?: boolean
                    } = {}
                    if (hasError) {
                        labelProps.optional = (
                            <Typography variant="caption" color="error">
                                {DynamicParamsService.resolveLang(
                                    step.errorMsg
                                )}
                            </Typography>
                        )
                        labelProps.error = true
                    }
                    return (
                        <Step key={step.name} {...stepProps}>
                            <StepLabel {...labelProps}>
                                <span className={stepClassName}>
                                    {DynamicParamsService.resolveLang(
                                        step.displayName
                                    )}
                                </span>
                            </StepLabel>
                        </Step>
                    )
                })}
            </StyledStepper>
            {steps.map((item: any, index: any) => {
                return (
                    <StepperItem
                        key={item.name}
                        name={item.name}
                        activeStep={activeStep}
                        fields={item.fields}
                        index={index}
                        error={hasError}
                    />
                )
            })}
        </Box>
    )
}
export default CwStepper
